const play_button = document.querySelector(".video-section-wrapper .play");
const video_source = document.querySelector(
  ".video-section-wrapper video source"
);
const video = document.querySelector(".video-section-wrapper video");
const image = document.querySelector(".video-section-wrapper .image");
play_button.addEventListener("click", () => {

  video.play();
  play_button.classList.remove("active");
  image.classList.remove("active");
  video.classList.add("active");
});
